export default function CardSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="w-full animate-pulse bg-background-200" style={{ aspectRatio: "2 / 3" }}></div>
          <div className="space-y-2 p-4">
            <div className="h-4 w-3/4 animate-pulse rounded bg-background-200"></div>
            <div className="h-3 w-1/2 animate-pulse rounded bg-background-200"></div>
          </div>
        </div>
      ))}
    </div>
  );
}